import { render, staticRenderFns } from "./CreateContentGroup.vue?vue&type=template&id=700b1a68"
import script from "../../services/upload/create-content-group.js?vue&type=script&lang=js&external"
export * from "../../services/upload/create-content-group.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/css/teacher/create-course.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports